import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AsyncSubject, Subject } from 'rxjs';
import { AppConfig } from 'src/app/app.config';

@Injectable({
  providedIn: 'root'
})
export class DiscussionService {

  public rootUrl = '';
  public redirectBaseUrl = '';

  public newPostRefresh = new Subject<any>();
  public newStoriesRefresh = new Subject<any>();

  public answerCountRefresh = new Subject<any>();
  public shareCountRefresh = new Subject<any>();

  public storyId = '';

  public selectedStoryObj ={};

  constructor( private http: HttpClient,private config: AppConfig) {
    this.rootUrl = this.config.getConfig('DISCUSS_API_URL');
    this.redirectBaseUrl = this.config.getConfig('DISCUSS_BASE_URL');
  }

  setCustomFieldsData() {
    this.rootUrl = this.config.getConfig('DISCUSS_API_URL');
    this.redirectBaseUrl = this.config.getConfig('DISCUSS_BASE_URL');
  }



  getTodaysForum(user_id,page) {
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/discuss/todays?page='+page+'&user_id='+user_id);
  }

  getImportantForum(user_id,page){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/discuss/important-posts?page='+page+'&user_id='+user_id);
  }

  getUnansweredForums(user_id,page){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/discuss/unanswered-posts?page='+page+'&user_id='+user_id);
  }

  getDiscussionById(id){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/discuss/'+id);
  }

  getDiscussionBySlug(user_id, slug){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/discuss/byslug/'+slug+'?user_id='+user_id);
  }
  getCommentByDiscussionId(formId, page){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/comments-by-forum/'+formId+'?page='+page);
  }
  getChildCommentByDiscussionId(formId, commentId, page){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/child-comments-by-forum/'+formId+'/'+commentId+'?page='+page);
  }
  getReviewOtherPosts() {
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/discuss/');
  }
  getExpertVerifiedDiscucss(){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/discuss/expert-verified-posts')
  }
  getVerifiedByOtherDiscuss(){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/discuss/answered-posts')
  }
  getUserRecentPosts(userId,page) {
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/discuss/by-user/'+userId+'?page='+page);
  }
  getExams(){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/discuss/get-categories-main')
  }
  getSubjects(){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/discuss/get-subjects')
  }
  getExamsWithSubExams(){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/discuss/get-categories')
  }
  saveDiscussForm(data) {
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.rootUrl + 'api/discuss/create', data);
  }

  addRemoveUpvote(formData){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.rootUrl + 'api/upvotes/addremoveupvote', formData);
  }
  addShare(formData){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.rootUrl + 'api/share/addshare', formData);
  }

  getStories(user_id, page, view){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/stories?page='+page+'&user_id='+user_id+'&user_view='+ view);
  }
  getMyStories(user_id, page){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/mystories?page='+page+'&user_id='+user_id);
  }
  getMyStoriesViews(story_id, page){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.rootUrl + 'api/stories-view-by-story?page='+page+'&story_id='+story_id);
  }
  addStories(data){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.rootUrl + 'api/stories/create', data);
  }
  viewedStory(data) {
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.rootUrl + 'api/stories/addstoryview', data);
  }
  postFile(fileToUpload: File) {
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    const endpoint = this.config.getConfig('BASEURL')+'assets/discuss_images';
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    return this.http.post(endpoint, formData);
}

  saveMCQAnswer(formData) {
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.rootUrl + 'api/discuss/addmcqanswer', formData);
  }

  addComment(formData){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.rootUrl + 'api/comments/create', formData);
  }
  reportPost(formData){
    if(!this.rootUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.rootUrl + 'api/discuss/reports', formData);
  }
}
